import angular from 'angular';
import moment from 'moment';
import _ from 'lodash';

const userHelperServiceFactory = function UserHelperServiceFactory($filter, $rootScope, LoginService, $log, StorageService, NewTokenService, $q) {
        "ngInject";

      const DURATION_TEMPORARY_ACCOUNT = 60;

      const outputTranslater = (translationString, translate = true) => {
        if (translate) {
          return $filter('translate')(translationString);
        } else {
          return translationString;
        }
      };

      //TODO centralizzali!
      const MERCHANT_TYPE = {
          "EASY": 0,
          "BUSINESS": 1,
          "DOUBLE": 2
        },
        TRANSLATE_LEVEL_CONVENTIONS = [
          'btemp',
          'b',
          'a'
        ],
        TRANSLATE_MERCHANT_NAME_CONVENTIONS = [
          'consumer',
          'business.easy',
          'merchant'
        ];

      const service = {
        userProfile: undefined,

        /**
         * isUserLogged - controlla se l'utente è connesso. Sfrutta il localStorage
         *
         * @return {Boolean} true se l'utente è connesso
         *
         */
        isUserLogged : () => {
          return Boolean(StorageService.getLocalStorage("UserContext")); //si è già loggato
              // NewTokenService.loggedIn; //non è andato in timeout
        },

        /**
         * getUserWalletLevelLabel - Ottiene l'etichetta del livello di tinaba associato all'utente
         *
         * @return {String}  "Level C", "Level B", "Level A", "Level A Biz" (il vecchio easy), "Level A Corporate".
         * Ritorna stringa vuota se l'utente non e' ancora connesso.
         *
         */
        getUserWalletLevelLabel: () => {
          const
            walletLevel = service.getUserLevel(),
            isMerchant = !NewTokenService.isLoggedAsConsumer() || service.isMerchantEasy(),
            isMerchantEasy = (service.isMerchantEasy());

          let merchantLabelIndex = 0;
          if (isMerchant) {
            if (isMerchantEasy) {
              merchantLabelIndex = 1;
            } else {
              merchantLabelIndex = 2;
            }
          }
          const
            levelLabel = TRANSLATE_LEVEL_CONVENTIONS[walletLevel],
            merchantLabel = TRANSLATE_MERCHANT_NAME_CONVENTIONS[merchantLabelIndex];

          if (levelLabel !== undefined && merchantLabel !== undefined) {
            return $filter('translate')("t.app.util.level." + levelLabel + ".label." + merchantLabel);
          } else {
            return "";
          }

        },
        /**
         * getAccountStatus - Ottiene lo stato dell'account (abilitato, upgrading...)
         *
         * @return {String}  account status
         */
        getAccountStatus: () => {
          const UserContextString = StorageService.getLocalStorage('UserContext');
          //TODO brutto
          if (UserContextString && UserContextString !== "undefined") {
            const UserContext = JSON.parse(UserContextString);
            return UserContext.accountStatus;
          }
        },

        /**
         * getUserLevel - Ottiene il livello associato all'utente
         *
         * @return {Number}  0,1 o 2 a seconda del livello. -1 in caso di errore
         */
        getUserLevel: () => {

          const UserContextString = StorageService.getLocalStorage('UserContext');
          if (UserContextString && UserContextString !== "undefined") {
            //TODO brutto
            const UserContext = JSON.parse(UserContextString);
            if (NewTokenService.isLoggedAsConsumer() || service.isMerchantEasy()) {
              return UserContext.accountLevel;
            } else {
              const merchantWallet = _.filter(UserContext.associatedWallets, function(o) {
                return o.profile === 'merchant'; //consumer, hybrid
              });
              if (merchantWallet.length > 0) {
                //si ipotizza che un utente possa avere al massimo un account merchant
                return merchantWallet[0].accountLevel;
              } else {
                $log.error(`UserHelperService`, `getUserLevel`, `No merchant wallet found!`);
                return -1;
              }
            }
          } else {
            //non ho uno userlevel
            return -1;
          }
          // }
        },

        /**
         * isLevel1a
         *
         * @return {Boolean}
         */
        isLevel1a: () => {
          return (service.getUserLevel() <= 0);
        },


        /**
         *  getAccountExpirationDate
         *
         * Ottiene la data di scadenza dell'account, solo per i livelli 1a, false negli altri casi
         * @return {Promise(moment)} data di scadenza dell'account
         */
        getAccountExpirationDate: () => {
          return $q(function(resolve, reject){
            if (service.isLevel1a()) {
              service.getActiveProfile().then(function(result){
                if (result) {
                  resolve(moment(result.dataAttivazione || result.datacreazioneaccont).add(DURATION_TEMPORARY_ACCOUNT, 'days'));
                } else {
                  $log.error(`getAccountExpirationDate`, `account not initialized yet`);
                  resolve(false);
                }
              }, function(reason){
                $log.error(`UserHelperService`,`getAccountExpirationDate`, reason);
                reject(reason);
              });
            } else {
              resolve(false);
            }
          });
        },

        /**
         * getValidityDays - description
         *
         * @return {Number} Giorni rimanenti di validita' dell'account. Infinito se l'account e' di livello 1b o 2
         */
        getValidityDays: () => {
          return $q(function(resolve,reject){
            service.getAccountExpirationDate().then(function(result){
              const expirationDate = result;
              if (expirationDate) {
                resolve(moment().diff(expirationDate, 'days'));
              } else {
                resolve(Infinity);
              }
            }, function(reason){
              $log.error(`UserHelperService`, `getValidityDays`, reason);
              reject(reason);
            });
          });
        },

        /**
         * isLevel1b
         *
         * @return {Boolean}
         */
        isLevel1b: () => {
          return service.getUserLevel() === 1;
        },

        /**
         * isLevel2
         *
         * @return {Boolean}
         */
        isLevel2: () => {
          return service.getUserLevel() === 2;
        },

        /**
         * isMerchant - controlla se l'utente ha associato un profilo merchant, che sia easy, business o doppio.
         *
         * @return {Boolean}
         */
        isMerchant: () => {
          return NewTokenService.getMerchantType() !== "" && NewTokenService.getMerchantType() !== undefined;
        },
        /**
         * isMerchantEasy - controlla se l'utente ha associato un profilo merchant easy (ovvero con un unico conto ibrido).
         *
         * @return {Boolean}
         */
        isMerchantEasy: () => {
          return NewTokenService.getMerchantType() === 0;
        },

        /**
         * isLoggedAsConsumer : controlla se l'utente attualmente è connesso come Consumer
         *
         * @return {boolean}
         */
        isLoggedAsConsumer: () => {
          return !service.isMerchant() || NewTokenService.getMerchantType() === MERCHANT_TYPE.EASY || NewTokenService.isLoggedAsConsumer();
        },
        /**
         * isLoggedAsMerchant : controlla se l'utente attualmente è connesso come merchant
         *
         * @return {boolean}
         */
        isLoggedAsMerchant: () => {
          return !service.isLoggedAsConsumer();
        },
        /**
         * getWalletName - Ottieni wallet o conto o conto corrente, a seconda del livello dell'utente
         *
         * @param  {Boolean} [o] isCondensed = false
         * @param  {Boolean} [o] translate = true se la stringa va gia' tradotta
         * @return {String}  Il nome del wallet, come stringa da tradurre oppure (default) gia' tradotto
         */
        getWalletName: (isCondensed = false, translate = true) => {
          let translationString = "";
          if (service.isLevel2()) {
            if (isCondensed) {
              translationString = "t.app.helper.wallet.l2.condensed";
            } else {
              translationString = "t.app.helper.wallet.l2.extended";
            }
          } else {
            translationString = "t.app.helper.wallet.l1";
          }
          return outputTranslater(translationString, translate);
        },

        /**
         * getDocumentMovementsName - Ottieni il nome del documento (Estratto conto o movimenti wallet) a seconda del livello dell'utente
         *
         * @param  {Boolean} [o] translate = true se va gia' tradotto
         * @return {String}
         */
        getDocumentMovementsName: (translate = true) => {
          let translationString = "";
          if (service.isLevel2()) {
            translationString = "t.app.documents.title.normal";
          } else {
            translationString = "t.app.documents.select.movement";
          }
          return outputTranslater(translationString, translate);
        },

        /**
         * getActiveProfile - ritorna una promise per ottenere il profilo utente attivo in questo momento
         *
         * @returns {Promise}
         */
        getActiveProfile :  () => {
          if(NewTokenService.isLoggedAsConsumer()){
            return LoginService.getConsumerProfile();
          } else {
            return LoginService.getMerchantProfile();
          }
        },

        /**
         * isPendingUpgrade - Controlla se l'utente ha una richiesta di upgrade PENDING (ovvero, terminata lato frontend ma non lato back office)
         *
         * @returns {Promise} true se l'utente ha una richiesta di upgrade PENDING
         */
        isPendingUpgrade: () => {
          return $q(function(resolve, reject){
            LoginService.getTracciaturaPratica().then(function(result){
              const tracciatura = result.tracciaturaPratica1B ||  result.tracciaturaPratica2;
              if(tracciatura){
                resolve(tracciatura.segnalatobo !== 2);
              } else {
                resolve(false);
              }
            }, function(reason){
              $log.error(`UserHelperService`, `isSuspendedUpgrade`, reason);
              reject(reason);
            });
          });
        },

        /**
         * isSuspendedUpgrade - Controlla se l'utente ha una richiesta di upgrade SOSPESA (ovvero, interrotta lato frontend)
         *
         * @returns {Promise} true se l'utente ha una richiesta di upgrade SOSPESA
         */

        isSuspendedUpgrade : () => {
          return $q(function(resolve, reject){
            LoginService.getTracciaturaPratica().then(function(result){
              const tracciatura = result.tracciaturaPratica1B ||  result.tracciaturaPratica2;
              if(tracciatura){
                resolve(tracciatura.segnalatobo === 2);
              } else {
                resolve(false);
              }
            }, function(reason){
              $log.error(`UserHelperService`, `isSuspendedUpgrade`, reason);
              reject(reason);
            });
          });
        },

        /**
         * getPendingUpgradeStatus - Restituisce lo stato dell'upgrade
         * se è valorizzato a 2 vuol dire che l’utente non ha terminato ancora la richiesta di upgrade,
         * viceversa con 0 e 1 la richiesta deve essere analizzata da backoffice
         *
         * @returns {Promise} 0,1,2 se ha una pratica pending. undefined altrimenti.
         */

        getPendingUpgradeStatus : () => {
          return $q(function(resolve, reject){
            LoginService.getTracciaturaPratica().then(function(result){
              const tracciatura = result.tracciaturaPratica1B ||  result.tracciaturaPratica2;
              if(tracciatura){
                resolve(tracciatura.segnalatobo);
              } else {
                $log.debug('UserHelperService','getPendingUpgradeStatus','Nessuna tracciatura pratica trovata');
                resolve();
              }
            }, function(reason){
              $log.error(`UserHelperService`, `getPendingUpgradeStatus`, reason);
              reject(reason);
            });
          });

        }
      };

      $rootScope.$on("USER_PROFILE_UPDATED", function() {
        // if(NewTokenService.isLoggedAsConsumer()){
        service.getActiveProfile().then(function(result){
          service.userProfile = result;
        }, function(reason){
          $log.debug(`UserHelperService`, `getActiveProfile failed`, reason);
          service.userProfile = undefined;
        });
      });

      return service;
    }

export default userHelperServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/userHelper.factory.js
 **/